import script from "./Organization.vue?vue&type=script&setup=true&lang=js"
export * from "./Organization.vue?vue&type=script&setup=true&lang=js"

import "./Organization.vue?vue&type=style&index=0&id=65625637&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65625637"]])

export default __exports__